import { StyleSheet } from '@react-pdf/renderer'
import { COLORS } from './constants'

export const styles = StyleSheet.create({
  // Page
  page: {
    paddingTop: 40,
    paddingRight: 40,
    paddingBottom: 50,
    paddingLeft: 40,
    fontFamily: 'Helvetica',
    fontSize: 10,
    lineHeight: 1.4,
    color: COLORS.black
  },

  // Section Header
  sectionHeader: {
    marginBottom: 15
  },
  headerTopBar: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 8
  },
  headerTopBarText: {
    backgroundColor: COLORS.purple,
    color: COLORS.white,
    paddingVertical: 3,
    paddingHorizontal: 12,
    fontSize: 9
  },
  headerMainRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    marginBottom: 12
  },
  sectionLetterBox: {
    width: 50,
    height: 60,
    backgroundColor: COLORS.purple,
    justifyContent: 'center',
    alignItems: 'center'
  },
  sectionLetter: {
    color: COLORS.white,
    fontSize: 36,
    fontWeight: 'bold'
  },
  headerTitleArea: {
    flex: 1,
    paddingLeft: 15,
    justifyContent: 'center'
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: COLORS.black
  },
  ricsText: {
    fontSize: 18,
    fontWeight: 'bold',
    letterSpacing: 2,
    color: COLORS.black,
    paddingTop: 5
  },

  // Limitations Box
  limitationsContainer: {
    marginLeft: 65,
    marginBottom: 10
  },
  limitationsLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 4
  },
  limitationsBox: {
    borderWidth: 1,
    borderColor: '#999',
    borderRadius: 4,
    minHeight: 20,
    padding: 6
  },
  limitationsText: {
    fontSize: 9
  },

  // Rating Legend
  ratingLegend: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 6,
    marginBottom: 15,
    alignItems: 'center'
  },

  // Category Block
  categoryContainer: {
    marginLeft: 65,
    marginBottom: 12
  },
  categoryHeading: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 4
  },
  categoryBox: {
    borderWidth: 1,
    borderColor: '#999',
    borderRadius: 4
  },
  categoryContent: {
    flexDirection: 'row',
    padding: 8
  },
  categoryDescription: {
    flex: 1,
    fontSize: 9,
    lineHeight: 1.4
  },
  categoryRating: {
    marginLeft: 10,
    flexShrink: 0
  },

  // Empty category (minimal)
  emptyCategoryBox: {
    borderWidth: 1,
    borderColor: '#999',
    borderRadius: 4,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 8,
    minHeight: 35
  },

  // Photo Grid
  photoSection: {
    padding: 8
  },
  photoRow: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 8
  },
  photoContainer: {
    flex: 1,
    alignItems: 'center'
  },
  photo: {
    maxWidth: 200,
    maxHeight: 160,
    objectFit: 'contain',
    borderRadius: 8
  },
  photoLabel: {
    fontSize: 8,
    marginTop: 3,
    color: COLORS.darkGrey
  },

  // Footer
  footer: {
    position: 'absolute',
    bottom: 15,
    left: 40,
    right: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
    color: COLORS.black
  },

  // Utilities
  row: {
    flexDirection: 'row'
  },
  spacer: {
    flex: 1
  }
})
